import React, { ReactNode, FC, Children } from "react";
import { useRouter } from "next/router";
import Link from "next/link";

interface ActiveLinkProps {
  href: string;
  children: ReactNode;
}

const ActiveLink: FC<ActiveLinkProps> = ({ href, children }) => {
  const router = useRouter();
  const className = router.pathname === href ? "active" : "";
  const child: any = Children.only(children);

  return (
    <a
      onClick={() => {
        window.location.href = `https://www.ezylegal.in${href}`;
      }}
    >
      {React.cloneElement(child, {
        className: className || null,
      })}
    </a>
  );
};

export default ActiveLink;
